import { createComment, deleteComment, editComment, getComments, getMentionStaff } from './comment.action';

export { commentReducer } from './comment.reducer';
export { watchComments } from './comment.saga';
export { commentThreadKey } from './comment.constants';
export {
    GET_COMMENTS,
    CREATE_COMMENT,
    EDIT_COMMENT,
    DELETE_COMMENT,
    GET_MENTION_STAFF,
} from './comment.type';

export const commentActions = {
    getComments,
    createComment,
    editComment,
    deleteComment,
    getMentionStaff,
};
